var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRejectedInvoice = function SvgRejectedInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "1724 792 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11061",
    fill: "#26890d",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1740 792c-8.876 0-16 7.18-16 16 0 8.876 7.18 16 16 16s16-7.18 16-16-7.18-16-16-16m0 30.926c-8.198 0-14.87-6.672-14.87-14.87 0-8.197 6.672-14.869 14.87-14.869s14.87 6.672 14.87 14.87c0 8.197-6.672 14.869-14.87 14.869",
    "data-name": "Path 280411"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Error - Free interface icons-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1738.704 816.408h-4.873a2.197 2.197 0 0 1-2.195-2.195v-14.048c0-1.211.984-2.196 2.195-2.196h10.536c1.21 0 2.195.985 2.195 2.196v6.172a.44.44 0 0 1-.878 0v-6.172c0-.727-.591-1.317-1.317-1.317h-10.536c-.726 0-1.317.59-1.317 1.317v14.048c0 .726.59 1.317 1.317 1.317h4.873a.44.44 0 0 1 0 .878Z",
    "data-name": "Path 9306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.489 804.431h-8.78a.44.44 0 0 1 0-.878h8.78a.44.44 0 0 1 0 .878Z",
    "data-name": "Path 9307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.977 806.5h-5.268a.44.44 0 0 1 0-.878h5.268a.44.44 0 0 1 0 .878Z",
    "data-name": "Path 9308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.099 802.36h-4.39a.44.44 0 0 1 0-.879h4.39a.44.44 0 0 1 0 .879Z",
    "data-name": "Path 9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.301 816.665h-8.142c-.612 0-1.11-.498-1.11-1.11 0-.218.06-.422.174-.592l4.062-6.648a1.1 1.1 0 0 1 .945-.533c.39 0 .754.207.949.539l4.067 6.656c.106.156.166.36.166.577 0 .613-.499 1.11-1.11 1.11Zm-4.07-8.143a.358.358 0 0 0-.31.173l-4.075 6.668a.329.329 0 0 0-.057.191c0 .204.167.37.37.37h8.142a.37.37 0 0 0 .37-.37.313.313 0 0 0-.048-.177l-4.08-6.676a.362.362 0 0 0-.313-.179Z",
    "data-name": "Path 9310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.23 813.705a.37.37 0 0 1-.37-.37v-2.96a.37.37 0 0 1 .74 0v2.96a.37.37 0 0 1-.37.37Z",
    "data-name": "Path 9311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.86 814.716a.37.37 0 1 1 0 .1z",
    "data-name": "Ellipse 23"
  })))));
};
export default SvgRejectedInvoice;